import { render, staticRenderFns } from "./starLevelFlow.vue?vue&type=template&id=5167ed6c&scoped=true"
import script from "./starLevelFlow.vue?vue&type=script&lang=js"
export * from "./starLevelFlow.vue?vue&type=script&lang=js"
import style0 from "./starLevelFlow.vue?vue&type=style&index=0&id=5167ed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167ed6c",
  null
  
)

export default component.exports